import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URI}/api`,
});

export const getContent = () => api.get('/');

export const insertNews = (payload) => api.post('/news', payload, { headers: { 'Content-Type': 'multipart/form-data' } });

export const insertServices = (payload) => api.post('/services', payload, { headers: { 'Content-Type': 'multipart/form-data' } });

export const updateAboutById = (id, payload) => api.put(`/about/${id}`, payload);

export const updateServicesFileById = (id, payload) => api.put(`/servicesFile/${id}`, payload, { headers: { 'Content-Type': 'multipart/form-data' } });

export const updateServicesById = (id, payload) => api.put(`/services/${id}`, payload);

export const updateAdminById = (id, payload) => api.put(`/admin/${id}`, payload);

export const updateNewsFileById = (id, payload) => api.put(`/newsFile/${id}`, payload, { headers: { 'Content-Type': 'multipart/form-data' } });

export const updateNewsById = (id, payload) => api.put(`/news/${id}`, payload);

export const updateMainById = (id, payload) => api.put(`/main/${id}`, payload, { headers: { 'Content-Type': 'multipart/form-data' } });

export const updateContactsById = (id, payload) => api.put(`/contacts/${id}`, payload);

export const deleteNewsById = (id) => api.delete(`/news/${id}`, { headers: { 'Content-Type': 'multipart/form-data' } });

export const deleteServicesById = (id) => api.delete(`/services/${id}`);

export const swapKeysById = (payload) => api.put('/services', payload);

export const getImage = (filename) => api.get(`/image/${filename}`, { headers: { 'Content-Type': 'multipart/form-data' } });

const apis = {
  getContent,
  insertNews,
  insertServices,
  updateAboutById,
  updateServicesById,
  updateNewsById,
  updateNewsFileById,
  updateMainById,
  updateContactsById,
  deleteNewsById,
  deleteServicesById,
  swapKeysById,
  getImage,
};

export default apis;
